import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

import { blue } from "@material-ui/core/colors";

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
});

export default function DocumentFrame_Dialog(props) {
    const classes = useStyles();
    const { onClose, open, documents, documentType, showGenerateOptionInPopper } = props;

    const handleClose = () => {
        onClose(null);
    };

    const handleListItemClick = (value) => {
        
        onClose(value);
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">Create a {documentType}...</DialogTitle>
            <List>
                {showGenerateOptionInPopper && (
                    <ListItem button onClick={() => handleListItemClick("")} key={""}>
                        <ListItemAvatar>
                            <Avatar>
                                <CreateNewFolderIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={"Generate New " + documentType} />
                    </ListItem>
                )}
                <ListItem button style={{ alignItems: "start" }}>
                    <ListItemAvatar>
                        <Avatar className={classes.avatar}>
                            <FileCopyIcon />
                        </Avatar>
                    </ListItemAvatar>
                    {/* <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-label" style={{ whiteSpace: "nowrap" }}>Load Previously Generated {documentType}...</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={""}
              style={{ width: "500px", fontSize: "100%" }}
              onChange={(e) => handleListItemClick(e.target.value)}
            >
              {documents && documents.map((document) => (
              ))}
            </Select>
          </FormControl> */}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <InputLabel
                            id="demo-simple-select-label"
                            style={{ whiteSpace: "nowrap", marginBottom: "10px" }}
                        >
                            Load Previously Generated {documentType}...
                        </InputLabel>
                        {documents &&
                            documents.map((document) => (
                                <MenuItem
                                    value={document}
                                    style={{ fontSize: "100%", paddingLeft: "0px" }}
                                    onClick={(e) => handleListItemClick(document)}
                                >
                                    {document}
                                </MenuItem>
                            ))}
                    </div>
                </ListItem>
            </List>
        </Dialog>
    );
}

DocumentFrame_Dialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
